module.exports = __webpack_public_path__ + "static/img/logo.d57c957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = 889
// module chunks = 1